module.exports = ".w-timepicker-dialog {\n  padding: 0;\n  margin: -24px;\n  width: calc(100% + 48px); }\n"